// The H5 dashboard sections. Wire values mirror the backend DashboardSection enum. Sent on
// dashboard time-series queries as the per-(project, section) H4/H5 routing key: the backend
// serves a tagged query from H5 exactly when that section is flagged for the project, and
// serves empty for sources H5 can't read yet rather than mixing in H4 data.
export enum DashboardSection {
  ShortTerm = 'short-term',
  Seasonal = 'seasonal',
  Annual = 'annual',
}
